import React, { useEffect, useState} from 'react';
import Grid from '@material-ui/core/Grid'
import FiltersSection from '../../Filters/FiltersSection'
import { Typography, TextField, MenuItem } from '@material-ui/core';
import {getRaspaReportData, getRaspas} from "../../../actions/raspaCycleActions";
import {useDispatch, useSelector} from "react-redux";
import {makeStyles} from "@material-ui/core/styles";
import ImpressaoCall from "./ImpressaoCall";
import {useRouteMatch} from "react-router-dom";
import mock from "./mock.json";
import mockFilter from "./mockFilter.json";

//TODO: revisar banco de dados avancoEXtra

//const stations = [1,2,3,4]

const useStyles = makeStyles(theme => ({

    paperA4: {
        size: "A4",
        width: '210mm',
        height: '297mm'
    },

    dashboardSection: {
        // padding: "5px"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
      marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
      marginBottom: theme.spacing(1) * 5,


    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
      paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
}));

const RaspaProducaoPdf = () => {
   const classes = useStyles();

   const routes = useRouteMatch();
   console.log('routes',routes);

   const storeRaspaReportData = useSelector( state => state.raspaCycles.raspaReportData);
   const storeFilter = useSelector(state => state.filter);
   const raspas = useSelector(state => state.raspaCycles.Raspas);
   const estabelecimentoId = useSelector(state => state.filter.estabelecimentoId);

   const isMock = routes.path === '/report/mock';
   const raspaReportData = isMock ? mock : storeRaspaReportData;
   const filter = isMock ? mockFilter : storeFilter;

   const [selectedRaspaId, setSelectedRaspaId] = useState('');


    const dispatch = useDispatch();
    const isLoading = useSelector(state =>  state.raspaCycles.isFetchingRaspaReportData);

    useEffect(() => {
        if (routes.path !== '/report/mock') {
            setSelectedRaspaId('');
            dispatch(getRaspas());
        }
    }, [estabelecimentoId]);

    useEffect(() => {
        if (raspas && raspas.length > 0 && !selectedRaspaId) {
            setSelectedRaspaId(raspas[0].id);
        }
    }, [raspas]);

    useEffect(() => {
        if (selectedRaspaId && routes.path !== '/report/mock') {
            dispatch(getRaspaReportData(selectedRaspaId));
        }
    }, [selectedRaspaId]);

    const onFilterClick = () => {
        dispatch(getRaspaReportData(selectedRaspaId));
    }


     const content = () => {
        if (isLoading || raspaReportData === null || raspaReportData.periodo === null) {
            return (
                <Grid item  xs={12} sm={12} lg={12} xl={12}>
                    <Typography variant="h6" align="center" className={classes.sectionTitle}>
                        Sem dados...
                    </Typography>
                </Grid>
            )
        } else {
            return (

                    <ImpressaoCall
                        raspaReportData={raspaReportData}
                        filter={filter}
                        isLoading={isLoading}  />
            )
        }
    }


        return (
            <React.Fragment>
                <Grid container direction="column" className={classes.dashboardSection}>
                    <Grid item xs={12}>
                        <FiltersSection showPeriod={true} showBeforePeriod={false}
                                        showBenchPeriod={false}
                                        onButtonClick={onFilterClick}
                                        loading={isLoading}
                                        onFilterClick={onFilterClick}>
                            <TextField
                                select
                                label="Raspa"
                                value={selectedRaspaId}
                                onChange={(e) => setSelectedRaspaId(e.target.value)}
                                style={{minWidth: 200, marginLeft: 8, marginRight: 8}}
                                InputLabelProps={{ shrink: true }}
                            >
                                {raspas && raspas.map((raspa) => (
                                    <MenuItem key={raspa.id} value={raspa.id}>
                                        {raspa.numero || raspa.name || `Raspa ${raspa.id}`}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </FiltersSection>
                    </Grid>
                </Grid>
                <Grid item  xs={12} sm={12} lg={12} xl={12}>
                    <Typography variant="h4" align="center" className={classes.sectionTitle}>
                        RASPA - PRODUÇÃO
                    </Typography>
                    {content()}


                </Grid>

            </React.Fragment>
    );
}

export default (RaspaProducaoPdf);
